var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import classNames from 'classnames';
import { getDateStringFromZonedDate, getZonedDateFromDateString } from 'ezyvet-fe-helpers';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { isDate, isValid, parseISO } from 'date-fns';
var useStyles = makeStyles(function (theme) {
    return createStyles({
        root: function () { return ({
            borderRadius: theme.shape.borderRadius || 3,
            paddingLeft: '2px',
        }); },
        bordered: {
            border: function (props) {
                return props.bordered ? "1px solid ".concat(theme.commonSettings.borderColor) : '1px solid transparent';
            },
        },
        input: {
            maxHeight: '1em',
        },
        error: function () { return ({
            border: '1px solid red',
        }); },
        icon: {
            '& svg': {
                height: '1rem',
                width: '1rem',
                fill: theme.commonSettings.borderColor,
            },
        },
    });
});
/**
 * @deprecated
 */
function DateProvider(props) {
    var Input = props.Input, timezone = props.timezone, onChange = props.onChange, label = props.label, value = props.value, disabled = props.disabled, name = props.name, required = props.required, fullWidth = props.fullWidth, iconKeyboardNavigable = props.iconKeyboardNavigable, format = props.format, isErrorField = props.isErrorField, bordered = props.bordered, autoOk = props.autoOk, disableFuture = props.disableFuture, disablePast = props.disablePast, maxDate = props.maxDate, minDate = props.minDate, errorMessage = props.errorMessage, TextFieldComponent = props.TextFieldComponent, otherProps = __rest(props, ["Input", "timezone", "onChange", "label", "value", "disabled", "name", "required", "fullWidth", "iconKeyboardNavigable", "format", "isErrorField", "bordered", "autoOk", "disableFuture", "disablePast", "maxDate", "minDate", "errorMessage", "TextFieldComponent"]);
    var classes = useStyles(props);
    var getValue = function (theDate) {
        if (!theDate)
            return null;
        if (isDate(theDate))
            return theDate;
        if (!isValid(parseISO(theDate)))
            return theDate;
        return getZonedDateFromDateString(theDate, timezone);
    };
    var _a = useState(getValue(value)), date = _a[0], setDate = _a[1];
    var _b = useState(isErrorField), error = _b[0], setError = _b[1];
    useEffect(function () {
        if (getValue(value) !== date)
            setDate(getValue(value));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    var onChangeLocal = function (newDate) {
        setDate(newDate);
    };
    var onErrorLocal = function (err, val) {
        if (err !== '' || isErrorField)
            setError(true);
        else
            setError(!val && required);
    };
    var onAcceptDate = function (newDate) {
        var theDate = newDate;
        // if it's valid return the timezone date
        if (isValid(theDate)) {
            theDate = getDateStringFromZonedDate(theDate, timezone);
        }
        onChange(theDate);
    };
    var onBlurLocal = function () {
        onAcceptDate(date);
    };
    var getButtonProps = function () {
        var result = {
            style: {
                padding: '0.3em',
            },
        };
        if (!iconKeyboardNavigable) {
            result.tabIndex = -1;
        }
        result.disableRipple = true;
        result.className = classes.icon;
        return result;
    };
    return (React.createElement(MuiPickersUtilsProvider, { utils: DateFnsUtils },
        React.createElement(Input, __assign({ autoComplete: 'off', variant: 'inline', autoOk: autoOk, label: label, value: date, disabled: disabled, format: format, name: name, error: !!error, required: required, fullWidth: fullWidth, helperText: error ? errorMessage : '', disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChangeLocal, onError: onErrorLocal, onAccept: onAcceptDate, onBlur: onBlurLocal, KeyboardButtonProps: getButtonProps(), TextFieldComponent: TextFieldComponent, FormHelperTextProps: {
                component: function () { return React.createElement(React.Fragment, null); },
            }, InputProps: {
                disableUnderline: true,
                classes: {
                    error: classes.error,
                    root: classNames(classes.root, classes.bordered),
                    input: classes.input,
                },
            }, InputLabelProps: {
                shrink: true,
            } }, otherProps))));
}
DateProvider.defaultProps = {
    timezone: 'Etc/UTC',
    iconKeyboardNavigable: false,
    isErrorField: false,
    bordered: false,
    autoOk: true,
    disableFuture: false,
    disablePast: false,
};
export default DateProvider;
//# sourceMappingURL=DateProvider.js.map